"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkLicenseValidity = exports.makeActionCreator = void 0;
function makeActionCreator(type) {
    return (payload) => ({ type, payload });
}
exports.makeActionCreator = makeActionCreator;
const checkLicenseValidity = (authResult) => {
    const license = authResult.license;
    const isTenantExpired = authResult.tenant?.status !== "ACTIVE" /* TenantStatus.ACTIVE */;
    return license?.endDate ? new Date().getTime() < new Date(license.endDate).getTime() && !isTenantExpired : false;
};
exports.checkLicenseValidity = checkLicenseValidity;
